// extracted by mini-css-extract-plugin
export var buttons = "_9e-0";
export var buttonsActive = "_9e-h";
export var cancelConfirm = "_9e-1";
export var closeButton = "_9e-2";
export var column = "_9e-3";
export var container = "_9e-4";
export var detailHeader = "_9e-6";
export var detailTitle = "_9e-7";
export var detailsContent = "_9e-5";
export var header = "_9e-8";
export var headerWithClose = "_9e-9";
export var icon = "_9e-a";
export var infoIcon = "_9e-c";
export var informationContainer = "_9e-b";
export var sideDrawer = "_9e-d";
export var sideDrawerOpen = "_9e-e";
export var stickyFooter = "_9e-f";
export var typeOption = "_9e-g";